import { asSingleStyleConfig } from '../../../../utils/theme';
import { errorBaseStyles } from '../commonBasedStyles';
var baseStyleText = {
  color: errorBaseStyles.errorTextColor,
  mt: 2,
  fontWeight: 600,
  letterSpacing: 0
};
var baseStyleIcon = {
  marginRight: 2,
  color: errorBaseStyles.errorTextColor
};
var baseStyle = {
  text: baseStyleText,
  icon: baseStyleIcon
};
export var FormError = asSingleStyleConfig({
  baseStyle
});